import { getServerErrorString } from "utils/common";
import { openNotificationWithIcon } from "../utils/Notification";
import { request } from "./verb.services";

import { setStates, setCities } from "redux/actions/location.action";

// 3 for USA
export const getStates = (countryId=3) => {
  return (dispatch) => {
    return request(`Locations/${countryId}/States`, "get", null, true)
      .then((response) => {
        dispatch(setStates(response.data));
      })
      .catch((e) => {
        openNotificationWithIcon(
          "error",
          "Error!",
          getServerErrorString(e)
        );
      });
  };
};

export const getCities = (stateId) => {
  return (dispatch) => {
    return request(`Locations/Cities/${stateId}`, "get", null, true)
      .then((response) => {
        dispatch(setCities(response.data));
      })
      .catch((e) => {
        openNotificationWithIcon(
          "error",
          "Error!",
          getServerErrorString(e)
        );
      });
  };
};
